const takeover = {
  title: "Übernahmebörse",
  allDay: "Ganztägig",
  buttons: {
    history: "Geschichte",
  },
  view: {
    toTakeOver: "Zu übernehmen",
    toRelease: "Termine freigeben",
    toggleAriaLabel: "Ansicht der Übernahmebörse wählen",
  },
  filter: {
    allCounselors: "Alle Berater:innen",
    counselorAriaLabel: "Nach Berater:in filtern",
    dateFrom: "Datum von",
    dateTo: "Datum bis",
  },
  columns: {
    date: "Datum",
    time: "Uhrzeit",
    location: "Ort",
    service: "Dienst",
    details: "Details",
    from: "Von",
    takenOverBy: "Übernommen von",
    action: "Aktion",
  },
  actions: {
    takeOver: "Termin übernehmen",
    mark: "Zur Übernahme markieren",
    unmark: "Markierung zurücknehmen",
    reverse: "Übernahme zurücknehmen",
    markSelected: "Zur Übernahme markieren ({{value}})",
    unmarkSelected: "Markierung zurücknehmen ({{value}})",
  },
  takeOverDialog: {
    title: "Termin übernehmen",
    appointmentSection: "Zu übernehmender Termin",
    offeredBy: "Abgegeben von {{userCode}}",
    yourAppointmentsSection: "Ihre Termine am {{date}}",
    yourAppointmentsRangeSection: "Ihre Termine von {{startDate}} bis {{endDate}}",
    noOwnAppointments: "Keine eigenen Termine an diesem Tag.",
    cancel: "Abbrechen",
    confirm: "Übernehmen",
  },
  revertDialog: {
    title: "Übernahme zurücknehmen",
    text: "Möchten Sie die Übernahme dieses Termins wirklich zurücknehmen? Der Termin wird wieder zur Übernahme freigegeben.",
    confirm: "Zurücknehmen",
  },
  messages: {
    marked: "Termin zur Übernahme markiert.",
    unmarked: "Markierung zurückgenommen.",
    takenOver: "Termin übernommen.",
    reversed: "Übernahme zurückgenommen.",
  },
  history: {
    title: "Geschichte – Übernahmen",
    countLabel_one: "{{count}} Übernahme",
    countLabel_other: "{{count}} Übernahmen",
    searchPlaceholder: "Übernahmen finden",
    filter: {
      from: "Von",
      to: "Bis",
      givenUpBy: "Abgegeben von",
      takenOverBy: "Übernommen von",
    },
    columns: {
      timestamp: "Zeitpunkt",
      appointment: "Termin",
      givenUpBy: "Abgegeben von",
    },
  },
};

export default takeover;
